module.exports = __webpack_public_path__ + "static/img/co1.5140cdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cooperation/co1.jpg
// module id = RDF3
// module chunks = 11